import { ref, computed, onMounted, onUnmounted } from 'vue';
import { defineStore } from 'pinia';
import  axios  from 'axios'
import { API_URL } from '@/utils/constans'

export const useSettingsStore = defineStore('settings', () => {

	const isClient = typeof window !== 'undefined';	

	const settings = ref({})
	const widthWindow = ref(null);
    const heightWindow = ref(null);
	if(isClient) {
		widthWindow.value = window.innerWidth;
		heightWindow.value = window.innerHeight;
	}
	const cookies = computed(() => settings.value.documents?.cookies);
	const offer = computed(() => settings.value.documents?.offer);
	const policy_personal_data = computed(() => settings.value.documents?.policy_personal_data);
	const privacy_policy = computed(() => settings.value.documents?.privacy_policy);
	const rules = computed(() => settings.value.documents?.rules);

	const contactsEmail = computed(() => settings.value.contacts?.email);
	const contactsPhone = computed(() => settings.value.contacts?.phone_number);
	const contactsTelegram = computed(() => settings.value.contacts?.telegram);
	const contactsWhatsapp = computed(() => settings.value.contacts?.whatsapp);
	const contactsAddress = computed(() => settings.value.contacts?.address);
	const contactsWorkTime = computed(() => settings.value.contacts?.work_time);

	const rulesUrl = `${API_URL}/api/main/rules`;
	const mainSettings = async() => {
		try{
			const response = await axios.get(`${API_URL}/api/main/settings/courts`);
			settings.value = response.data;
		} catch(error) {
			console.log('error:',error);
		}
	}

	
	const getFaq = async(offset, limit) => {
		const params = {offset: offset, limit: limit};
		try {
			const { data } = await axios.get(`${API_URL}/api/feedback/faq?sites=2`, {params});
			return data;
		} catch(error) {
			console.log('getFaq:',error);
		}
	};
	const updateWidthWindow = () => { 
        widthWindow.value = window.innerWidth;
        heightWindow.value = window.innerHeight; 
    };
    onMounted(() => {
        window.addEventListener('resize', updateWidthWindow);        
    });
   
    onUnmounted(() => {
        window.removeEventListener('resize', updateWidthWindow);
    });
    return {
		mainSettings,
		getFaq,

		settings,
		cookies,
		widthWindow,
		offer,
		policy_personal_data,
		privacy_policy,
		rules,

		contactsAddress,
		contactsEmail,
		contactsPhone,
		contactsTelegram,
		contactsWhatsapp,
		contactsWorkTime,
		rulesUrl
	}
})
